import React, { useEffect } from 'react';

import { Modal, Panel } from '@myhealth-raccoon/components';
import { FeaturedIconProps } from '@myhealth-raccoon/components/src/components/featured-icon';

import { useBreakpoints } from 'src/hooks/useBreakpoints';
import { useScrollToTop } from 'src/hooks/useScrollToTop';

export type InlineModalProps = {
    className?: string;
    isOpen: boolean;
    onClose(isOpen: false): void;
    title?: React.ReactNode;
    icon?: FeaturedIconProps;
    size?: 'xl' | 'lg' | 'md' | 'sm';
    backdropClassname?: string;
};

export const InlineModal = ({
    className,
    children,
    isOpen,
    onClose,
    title,
    icon,
    size = 'lg',
    backdropClassname,
}: React.PropsWithChildren<InlineModalProps>) => {
    const scrollToTop = useScrollToTop();
    const screen = useBreakpoints();

    useEffect(() => {
        if (isOpen) {
            scrollToTop();
        }
    }, [isOpen, scrollToTop]);

    if (screen === 'sm' || screen === 'xs') {
        return (
            <Panel
                attachedTo="bottom"
                open={isOpen}
                setOpen={() => onClose(false)}
                title={<div className="ml-5 mt-5">{title}</div>}
                children={<div className="h-full border-t">{children}</div>}
                backdropClassname={backdropClassname}
            />
        );
    }

    return (
        <Modal
            unstyled
            open={isOpen}
            onClose={() => onClose(false)}
            title={<div className="ml-5 mt-5">{title}</div>}
            children={<div className="border-t">{children}</div>}
            panelClassname={className}
            icon={icon}
            size={size}
            backdropClassname={backdropClassname}
        />
    );
};
